import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, _mergeProps({ class: "base-table" }, _ctx.$attrs), _createSlots({ _: 2 }, [
    _renderList(_ctx.slotsList, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps({on: _ctx.isV2 ? scope.on : [], attrs: _ctx.isV2 ? scope.attrs : scope.props, props: _ctx.isV2 ? scope.attrs : scope.props, ...scope})))
        ])
      }
    })
  ]), 1040))
}